import React from 'react'
import {Icon} from '@chakra-ui/react'

const UpgradeCartIcon = (props) => {
    return (
        <Icon viewBox="0 0 16 16" fill="none" {...props}>
            <path
                d="M5.70313 14L5.70313 4.17187C5.70313 2.90335 6.73147 1.875 8 1.875C9.26853 1.875 10.2969 2.90335 10.2969 4.17188V14"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                opacity="0.1"
            />
            <path
                d="M2.64062 4.9375H13.3594L13.7519 9.64729C13.9061 11.498 13.9832 12.4234 13.552 13.0839C13.4132 13.2964 13.2402 13.4845 13.0399 13.6404C12.4175 14.125 11.4889 14.125 9.63176 14.125H6.36824C4.51107 14.125 3.58248 14.125 2.96013 13.6404C2.75985 13.4845 2.5868 13.2964 2.44802 13.0839C2.0168 12.4234 2.09391 11.498 2.24814 9.64728L2.64062 4.9375Z"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <path
                d="M5.70312 8V4.17188C5.70312 2.90335 6.73147 1.875 8 1.875C9.26853 1.875 10.2969 2.90335 10.2969 4.17188V8"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </Icon>
    )
}

export default UpgradeCartIcon
